import React from "react";
const Close = (props) => {
  return (
<svg
    fill="#fff"
    viewBox="0 0 32 32"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g id="SVGRepo_iconCarrier">
      <g transform="matrix(1,0,0,1,-336,-48)">
        <g transform="matrix(1,0,0,1.07692,48,-5.92308)">
          <path
            d="M316,65.857C316,65.365 315.789,64.892 315.414,64.544C315.039,64.196 314.53,64 314,64C309.48,64 298.52,64 294,64C293.47,64 292.961,64.196 292.586,64.544C292.211,64.892 292,65.365 292,65.857C292,68.328 292,72.672 292,75.143C292,75.635 292.211,76.108 292.586,76.456C292.961,76.804 293.47,77 294,77C298.52,77 309.48,77 314,77C314.53,77 315.039,76.804 315.414,76.456C315.789,76.108 316,75.635 316,75.143C316,72.672 316,68.328 316,65.857Z"
            style={{
              fill: "transparent",
            }}
          />
        </g>
        <path
          d="M349.374,53.451L344.424,62L342,62C341.204,62 340.441,62.316 339.879,62.879C339.316,63.441 339,64.204 339,65L339,75C339,75.796 339.316,76.559 339.879,77.121C340.441,77.684 341.204,78 342,78C346.52,78 357.48,78 362,78C362.796,78 363.559,77.684 364.121,77.121C364.684,76.559 365,75.796 365,75L365,65C365,64.204 364.684,63.441 364.121,62.879C363.559,62.316 362.796,62 362,62L359.131,62L354.618,53.465C354.861,53.032 355,52.532 355,52C355,50.344 353.656,49 352,49C350.344,49 349,50.344 349,52C349,52.526 349.136,53.021 349.374,53.451ZM342,64L362,64C362.265,64 362.52,64.105 362.707,64.293C362.895,64.48 363,64.735 363,65L363,75C363,75.265 362.895,75.52 362.707,75.707C362.52,75.895 362.265,76 362,76L342,76C341.735,76 341.48,75.895 341.293,75.707C341.105,75.52 341,75.265 341,75C341,75 341,65 341,65C341,64.735 341.105,64.48 341.293,64.293C341.48,64.105 341.735,64 342,64ZM352,68.586L349.707,66.293C349.317,65.903 348.683,65.903 348.293,66.293C347.903,66.683 347.903,67.317 348.293,67.707L350.586,70L348.293,72.293C347.903,72.683 347.903,73.317 348.293,73.707C348.683,74.097 349.317,74.097 349.707,73.707L352,71.414L354.293,73.707C354.683,74.097 355.317,74.097 355.707,73.707C356.097,73.317 356.097,72.683 355.707,72.293L353.414,70L355.707,67.707C356.097,67.317 356.097,66.683 355.707,66.293C355.317,65.903 354.683,65.903 354.293,66.293L352,68.586ZM350.907,54.794L346.735,62L356.869,62L353.064,54.805C352.734,54.931 352.375,55 352,55C351.615,55 351.246,54.927 350.907,54.794ZM352,51C352.552,51 353,51.448 353,52C353,52.552 352.552,53 352,53C351.448,53 351,52.552 351,52C351,51.448 351.448,51 352,51Z"
          style={{
            fill: "#fff",
          }}
        />
      </g>
    </g>
  </svg>
  );
};

export default Close;
